import EventsCardList from './EventsCardList';
import { EventsCardListProps, EventsCardListValueProps } from './types';

export type { EventsCardListProps, EventsCardListValueProps };
export default EventsCardList;
